import './Loading.scss';

export default function Loading() {
  return (
    <>
      <div className='spinner-bg'>
        <div
          className='spinner-border'
          role='status'
        >
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    </>
  );
}
